import React from "react";
import { getFieldProperties } from "../../../utils/formGenUtils/getFieldProperties";
import {
  FieldTypes,
  IFieldInstance,
} from "../../../types/fieldInstance.interface";
import { FormField } from "./FormField";
import { useIncidentFormContext } from "../incidentForm/IncidentContext";


const FormFieldGroup = ({
  formGroup,
  getError,
  childFormGroups,
}: {
  formGroup: IFieldInstance[];
  getError: any;
  childFormGroups?: any;
}) => {
  const { viewModel, formBasicDetails, shouldAllowInput, qaMode } =
    useIncidentFormContext();
  
  
  
  return (
    <>
      {formGroup.map((field: IFieldInstance) => {
        const {
          showToggleBox,
          typeControlName,
          typeControlLabel,
          inputName,
          secondaryBPFieldName,
          checkboxFieldName,
          checkboxLabel,
        } = getFieldProperties(field);
        
        const getDisabledFields =
          formBasicDetails &&
          Object.keys(formBasicDetails).includes(field.fieldName);

        const isDisabled = !shouldAllowInput || !!getDisabledFields;
        const allWoundFields = formGroup.filter(
          (field) => field.fieldType === FieldTypes.CustomWoundComp
        );

        return (
          <React.Fragment key={`${field.fieldName}-${field.id}`}>
            {viewModel[field.id] && (
              <FormField
                data-testid={`form-field-${field.fieldName}`}
                key={`${field.fieldName}-${field.id}`} // replace with UUID ?
                instance={field}
                getError={getError}
                showToggleBox={showToggleBox}
                typeControlName={typeControlName}
                typeControlLabel={typeControlLabel}
                inputName={inputName}
                secondaryBPFieldName={secondaryBPFieldName}
                checkBoxFieldName={checkboxFieldName}
                checkBoxLabel={checkboxLabel}
                disabled={isDisabled}
                qaMode={qaMode}
                childFormGroup={childFormGroups?.[field.id]}
                allWoundFields={allWoundFields}
              />
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default FormFieldGroup;
